export const SHOP_TYPE_PDD = 1
export const SHOP_TYPE_TAOBAO = 3
export const SHOP_TYPE_MINIPROGRAM = 4

export const MINIPROGRAM_API = {
	list: 'api/retail_shop/list',
	detail: 'api/retail_shop/detail',
	stateToggle: 'api/retail_shop/state_toggle',
	configSave: 'api/retail_shop/config_save',
	activate: 'api/retail_shop/miniprogram_activate',
}

export const MINI_CONFIG_API = {
	get: 'api/mini_config/get',
	save: 'api/mini_config/save',
	toggle: 'api/mini_config/toggle',
	shopOrderList: 'api/mini_config/shop_order_list',
	shopOrderDetail: 'api/mini_config/shop_order_detail',
	shopAfterSaleList: 'api/mini_config/shop_after_sale_list',
	shopAfterSaleDetail: 'api/mini_config/shop_after_sale_detail',
	distConfigSave: 'api/mini_config/dist_config_save',
	distUpgradeSave: 'api/mini_config/dist_upgrade_save',
	distMemberList: 'api/mini_config/dist_member_list',
	distMemberAdjust: 'api/mini_config/dist_member_adjust',
	distMemberCommission: 'api/mini_config/dist_member_commission',
	distMemberTeam: 'api/mini_config/dist_member_team',
	distMemberChain: 'api/mini_config/dist_member_chain',
	distMemberIncome: 'api/mini_config/dist_member_income',
	withdrawList: 'api/mini_config/withdraw_list',
	withdrawApprove: 'api/mini_config/withdraw_approve',
	withdrawPay: 'api/mini_config/withdraw_pay',
	withdrawReject: 'api/mini_config/withdraw_reject',
}

export const MINI_SHOP_PAGE_SIZES = [20, 30, 50]

export const MINI_SHOP_ORDER_TABS = [
	{ name: 'all', label: '全部' },
	{ name: '0', label: '待支付' },
	{ name: '1', label: '已支付' },
	{ name: '2', label: '已退款' },
	{ name: '3', label: '支付失败' },
	{ name: '4', label: '已关闭' },
]

export const MINI_SHOP_AFTER_SALE_TABS = [
	{ name: 'all', label: '全部' },
	{ name: '1', label: '待处理' },
	{ name: '2', label: '已取消' },
	{ name: '3', label: '已拒绝' },
	{ name: '4', label: '已受理' },
	{ name: '5', label: '处理中' },
	{ name: '6', label: '已完成' },
	{ name: '7', label: '已拒退' },
]

export const MINI_COMMENT_API = {
	list: 'api/mini_comment/list',
	audit: 'api/mini_comment/audit',
	hide: 'api/mini_comment/hide',
	reply: 'api/mini_comment/reply',
	pendingCount: 'api/mini_comment/pending_count',
}

export const MINI_COMMENT_TABS = [
	{ name: 'pending', label: '待审核' },
	{ name: 'approved', label: '已展示' },
	{ name: 'rejected', label: '已驳回' },
	{ name: 'hidden', label: '已隐藏' },
]

export const MINI_GOODS_API = {
	list: 'api/mini_goods/list',
	sync: 'api/mini_goods/sync',
	batchSync: 'api/mini_goods/batch_sync',
	unsync: 'api/mini_goods/unsync',
	batchUnsync: 'api/mini_goods/batch_unsync',
	detail: 'api/mini_goods/detail',
	sizeChFill: 'api/mini_goods/size_ch_fill',
}

export const MINI_GOODS_TABS = [
	{ name: 'syncable', label: '可同步' },
	{ name: 'synced', label: '已同步' },
	{ name: 'unsellable', label: '暂不可售' },
	{ name: 'name_missing', label: '名称缺失' },
	{ name: 'ch_missing', label: '缺中国码' },
]

export const MINI_GOODS_CIDS = [
	{ value: 1, label: '服装' },
	{ value: 2, label: '鞋' },
	{ value: 3, label: '配件' },
]

export const MINI_GOODS_CID_SHOE = 2

export function formatMiniGoodsBadge(count) {
	if (count == null || count === '') {
		return ''
	}
	const num = Number(count)
	if (isNaN(num)) {
		return ''
	}
	if (num > 99) {
		return '99+'
	}
	return String(num)
}

export function getApiErrorMessage(res, fallback) {
	const data = res && res.data
	if (!data) {
		return fallback
	}
	return data.message || data.msg || fallback
}

export function maskApiKey(key) {
	if (key == null || key === '') {
		return '-'
	}
	const str = String(key)
	if (str.length <= 6) {
		return str + '****'
	}
	return str.slice(0, 6) + '****'
}

export function getShopDisplayName(row) {
	if (!row) {
		return '-'
	}
	return row.mall_name || row.shop_name || '-'
}

export function canUseMiniprogram(myinfo) {
	if (!myinfo || typeof myinfo !== 'object') {
		return false
	}
	return Number(myinfo.can_use_miniprogram) === 1
}

/** list 按 id 倒序，取 type=4 中 id 最小的一条，勿用 list[0] */
export function pickMinIdMiniShop(list) {
	if (!Array.isArray(list) || !list.length) {
		return null
	}
	var picked = null
	for (var i = 0; i < list.length; i++) {
		var row = list[i]
		if (!row || row.id == null || row.id === '') {
			continue
		}
		if (row.type != null && Number(row.type) !== SHOP_TYPE_MINIPROGRAM) {
			continue
		}
		if (!picked || Number(row.id) < Number(picked.id)) {
			picked = row
		}
	}
	return picked
}

function validateBaseUrl(value) {
	const url = String(value || '').trim()
	if (!url) {
		return '请输入后端地址'
	}
	if (!/^https?:\/\/.+/i.test(url)) {
		return '后端地址需以 http:// 或 https:// 开头'
	}
	return ''
}

export function normalizeBaseUrl(value) {
	return String(value || '').trim().replace(/\/+$/, '')
}

export { validateBaseUrl }



// WEBPACK FOOTER //
// ./src/constants/retailPlatform.js